import React from 'react'
import { Show } from 'react-admin'

import { CustomShowLayout } from '../Generic'

import { renderModelFields } from '../Fields'

export const GenericShow = (props) => {
    if (!!props.fields && props.fields.length === 0) {
        return null
    } else if (props.permissions === null) {
        return null
    }

    return (
        <Show {...props}>
            <CustomShowLayout title={props.title} schema={props.schema}>
                {renderModelFields(props.fields, props.permissions)}
            </CustomShowLayout>
        </Show>
    )
}
